import { useDisclosure } from "@chakra-ui/hooks";
import { Modal, ModalOverlay } from "@chakra-ui/modal";
import { changePaymentStatus } from "api/graphQL_payments";
import React from "react";
import { toast } from "react-hot-toast";
import { MdChangeCircle, MdHighlightOff } from "react-icons/md";
import Checkbox from "components/checkbox";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import InputField from "components/fields/InputField";
import { Popover, PopoverTrigger, PopoverContent, PopoverHeader, PopoverArrow } from "@chakra-ui/react";
import { PANEL_STYLES } from "./InfoModal";

const ALL_STATUSES = [
  "APPROVED","REFUNDED","AUTHORIZED","CAPTURED","PENDING","CANCELLED","CREATED",
  "DECLINED","ERRORED","REFUND DECLINED","REJECTED","CHARGEBACK","ALERTED","HELD","DUPLICATE","DISPUTE",
];

const GLOBAL_ID = '__csm_dp_styles__';
function injectCsmStyles() {
  if (typeof document === 'undefined' || document.getElementById(GLOBAL_ID)) return;
  const s = document.createElement('style');
  s.id = GLOBAL_ID;
  s.textContent = `
    .csm-popper { z-index: 99999 !important; }
    .csm-popper .react-datepicker {
      font-family: 'Plus Jakarta Sans', sans-serif !important;
      border: 1.5px solid #e9d5ff !important;
      border-radius: 14px !important;
      box-shadow: 0 8px 32px rgba(15,23,42,0.16) !important;
      overflow: hidden;
      width: 280px !important;
    }
    .csm-popper .react-datepicker__month-container { width: 280px !important; float: none !important; }
    .csm-popper .react-datepicker__header {
      background: #faf5ff !important; border-bottom: 1px solid #e9d5ff !important;
      border-radius: 0 !important; padding-top: 10px !important;
    }
    .csm-popper .react-datepicker__current-month {
      font-size: 13px !important; font-weight: 700 !important; color: #4c1d95 !important;
    }
    .csm-popper .react-datepicker__day-names { display: flex !important; justify-content: space-around !important; }
    .csm-popper .react-datepicker__week { display: flex !important; justify-content: space-around !important; }
    .csm-popper .react-datepicker__day-name {
      font-size: 11px !important; font-weight: 700 !important; color: #a78bfa !important;
      flex: 1 !important; text-align: center !important;
    }
    .csm-popper .react-datepicker__day {
      font-size: 12px !important; font-weight: 500 !important; color: #374151;
      border-radius: 7px !important; flex: 1 !important; text-align: center !important; line-height: 2rem !important;
    }
    .csm-popper .react-datepicker__day:hover { background: #f3e8ff !important; color: #6d28d9 !important; }
    .csm-popper .react-datepicker__day--selected { background: #7c3aed !important; color: #fff !important; }
    .csm-popper .react-datepicker__day--keyboard-selected { background: #f3e8ff !important; color: #6d28d9 !important; }
    .csm-popper .react-datepicker__day--today { font-weight: 800 !important; color: #7c3aed !important; }
    .csm-popper .react-datepicker__day--outside-month { opacity: 0.35 !important; }
    .csm-popper .react-datepicker__navigation-icon::before { border-color: #7c3aed !important; }
    .csm-popper .react-datepicker__input-time-container {
      width: 100% !important; margin: 0 !important; padding: 8px 12px !important;
      border-top: 1.5px solid #e9d5ff !important; background: #faf5ff !important;
      display: flex !important; align-items: center !important; gap: 10px !important; box-sizing: border-box !important;
    }
    .csm-popper .react-datepicker-time__caption {
      font-size: 11.5px !important; font-weight: 700 !important; color: #4c1d95 !important; white-space: nowrap !important;
    }
    .csm-popper .react-datepicker-time__input-container { flex: 1 !important; }
    .csm-popper .react-datepicker-time__input input[type="time"] {
      width: 100% !important; padding: 5px 10px !important; border: 1.5px solid #e9d5ff !important;
      border-radius: 7px !important; font-family: 'Plus Jakarta Sans', sans-serif !important;
      font-size: 12.5px !important; color: #374151; background: #fff !important;
      outline: none !important; box-sizing: border-box !important;
    }
    .csm-popper .react-datepicker-time__input input[type="time"]:focus {
      border-color: #7c3aed !important; box-shadow: 0 0 0 2px rgba(124,58,237,0.1) !important;
    }

    /* Portal (mobile full-screen) overrides */
    .react-datepicker__portal {
      background: rgba(15,23,42,0.5) !important;
      backdrop-filter: blur(4px) !important;
      z-index: 99999 !important;
    }
    .react-datepicker__portal .react-datepicker {
      font-family: 'Plus Jakarta Sans', sans-serif !important;
      border: 1.5px solid #e9d5ff !important;
      border-radius: 18px !important;
      box-shadow: 0 24px 60px rgba(15,23,42,0.2) !important;
      overflow: hidden;
      width: 300px !important;
    }
    .react-datepicker__portal .react-datepicker__month-container { width: 300px !important; float: none !important; }
    .react-datepicker__portal .react-datepicker__header {
      background: #faf5ff !important; border-bottom: 1px solid #e9d5ff !important;
      border-radius: 0 !important; padding-top: 12px !important;
    }
    .react-datepicker__portal .react-datepicker__current-month {
      font-size: 14px !important; font-weight: 700 !important; color: #4c1d95 !important;
    }
    .react-datepicker__portal .react-datepicker__day-names { display: flex !important; justify-content: space-around !important; }
    .react-datepicker__portal .react-datepicker__week { display: flex !important; justify-content: space-around !important; }
    .react-datepicker__portal .react-datepicker__day-name {
      font-size: 12px !important; font-weight: 700 !important; color: #a78bfa !important;
      flex: 1 !important; text-align: center !important;
    }
    .react-datepicker__portal .react-datepicker__day {
      font-size: 13px !important; font-weight: 500 !important; color: #374151;
      border-radius: 8px !important; flex: 1 !important; text-align: center !important; line-height: 2.2rem !important;
    }
    .react-datepicker__portal .react-datepicker__day:hover { background: #f3e8ff !important; color: #6d28d9 !important; }
    .react-datepicker__portal .react-datepicker__day--selected { background: #7c3aed !important; color: #fff !important; }
    .react-datepicker__portal .react-datepicker__day--today { font-weight: 800 !important; color: #7c3aed !important; }
    .react-datepicker__portal .react-datepicker__navigation-icon::before { border-color: #7c3aed !important; }
    .react-datepicker__portal .react-datepicker__input-time-container {
      width: 100% !important; margin: 0 !important; padding: 10px 16px !important;
      border-top: 1.5px solid #e9d5ff !important; background: #faf5ff !important;
      display: flex !important; align-items: center !important; gap: 12px !important; box-sizing: border-box !important;
    }
    .react-datepicker__portal .react-datepicker-time__caption {
      font-size: 13px !important; font-weight: 700 !important; color: #4c1d95 !important; white-space: nowrap !important;
    }
    .react-datepicker__portal .react-datepicker-time__input-container { flex: 1 !important; }
    .react-datepicker__portal .react-datepicker-time__input input[type="time"] {
      width: 100% !important; padding: 8px 12px !important; border: 1.5px solid #e9d5ff !important;
      border-radius: 9px !important; font-size: 14px !important; color: #374151;
      background: #fff !important; outline: none !important; box-sizing: border-box !important;
    }
  `;
  document.head.appendChild(s);
}

const ChangeStatusModal = ({
  info, fetchPayments, transactionID, varient, enRefund, filterData, client_is_deleted,
}: {
  info?: any; fetchPayments: () => void; transactionID: string;
  varient?: string; enRefund?: any; filterData?: any; client_is_deleted?: boolean;
}) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [isLoading, setIsLoading] = React.useState<boolean>();
  const [isCloseModal, setIsCloseModal] = React.useState(false);
  const [form, setForm] = React.useState<any>({});
  const [isMobile, setIsMobile] = React.useState(false);
  const [popoverOpen, setPopoverOpen] = React.useState(false);

  React.useEffect(() => {
    injectCsmStyles();
    const check = () => setIsMobile(window.innerWidth <= 768);
    check();
    window.addEventListener('resize', check);
    return () => window.removeEventListener('resize', check);
  }, []);

  const handleClose = () => {
    setForm({});
    setIsCloseModal(true);
    setTimeout(() => { setIsCloseModal(false); onClose(); }, 300);
  };

  const handleInput = (e: any) => {
    const { name, value } = e.target;
    setForm((p: any) => ({ ...p, [name]: value === "true" ? true : value === "false" ? false : value }));
  };

  const handleSubmit = async () => {
    if (!form?.change_status_to) { toast.error("Please select a status"); return; }
    if (form?.isChangeStatusDate && !form?.changeStatusDate) { toast.error("Please select a date"); return; }
    if (form?.change_status_to === "APPROVED" && (!form?.transaction_id || !form?.auth_id)) {
      toast.error("Please enter all required fields"); return;
    }
    setIsLoading(true);
    const payload = {
      arn_number: form?.ARN_Number,
      reason: form?.ReasonToChange,
      current_status: form?.change_status_to,
      change_status_date: form?.isChangeStatusDate
        ? moment(form.changeStatusDate).format("MM-DD-YYYY, HH:mm:ss")
        : moment(info?.created_at?.replace("GMT", "")).format("MM-DD-YYYY, HH:mm:ss"),
      transaction_id: (form?.change_status_to === "APPROVED" || form?.change_status_to === "CHARGEBACK")
        ? form?.transaction_id : "not_applicable",
      auth_id: form?.change_status_to === "APPROVED" ? form?.auth_id : "not_applicable",
    };
    changePaymentStatus(payload, transactionID)
      .then(() => { toast.success("Status updated successfully"); handleClose(); filterData?.(); })
      .catch((err: any) => toast.error(err?.response?.data?.error ?? "Something went wrong"))
      .finally(() => setIsLoading(false));
  };

  return (
    <>
      <Popover trigger="hover" placement="bottom" closeOnBlur  closeOnEsc isOpen={popoverOpen && !isOpen} onOpen={() => setPopoverOpen(true)} onClose={() => setPopoverOpen(false)}>
        <PopoverTrigger>
          <button className="txn-action-btn" disabled={client_is_deleted} aria-label="Change status" onMouseEnter={() => !isOpen && setPopoverOpen(true)} onMouseLeave={() => setPopoverOpen(false)}
            onClick={() => { onOpen(); setForm((p: any) => ({ ...p, transaction_id: info?.et_id === "not_applicable" ? "" : info?.et_id })); }}>
            <MdChangeCircle size={14} />
          </button>
        </PopoverTrigger>
        <PopoverContent border="1px solid #e9d5ff" borderRadius="12px" bg="#fdf4ff" maxW="210px" p="0" overflow="hidden" zIndex="20">
          <PopoverHeader bg="#fae8ff" fontSize="12px" fontWeight="700" color="#6d28d9" borderBottom="1px solid #e9d5ff" px="12px" py="9px">Change Status</PopoverHeader>
          <PopoverArrow bg="#fdf4ff" />
        </PopoverContent>
      </Popover>

      <Modal isOpen={isOpen} onClose={handleClose}>
        <ModalOverlay bg="rgba(15,23,42,0.55)" backdropFilter="blur(4px)" />
        <div className={`pconfirm-panel${isOpen && !isCloseModal ? " pconfirm-panel--open" : " pconfirm-panel--close"}`}>
          <div className="pconfirm-glow pconfirm-glow--purple" />
          <div className="pconfirm-header pconfirm-header--purple">
            <div className="pconfirm-header-brand">
              <div className="pconfirm-header-logo"><MdChangeCircle size={20} color="#fff" /></div>
              <div>
                <h2 className="pconfirm-title">Change Payment Status</h2>
                <p className="pconfirm-sub">Current: <strong>{info?.status}</strong></p>
              </div>
            </div>
            <button className="pconfirm-close" onClick={handleClose}><MdHighlightOff size={22} /></button>
          </div>

          <div className="pconfirm-body">
            <div className="csm-field-group">
              <label className="csm-label">Current Status</label>
              <div className="csm-status-display">{info?.status || "—"}</div>
            </div>

            <div className="csm-field-group">
              <label className="csm-label">Change Status To <span className="csm-req">*</span></label>
              <select className="csm-select" name="change_status_to" value={form?.change_status_to ?? ""} onChange={handleInput}>
                <option value="">Select new status…</option>
                {ALL_STATUSES.map((s) => <option key={s} value={s} disabled={info?.status === s}>{s}</option>)}
              </select>
            </div>

            {form?.change_status_to === "APPROVED" && (
              <div className="csm-field-group">
                <InputField variant="auth" extra="w-full mb-2" label="Transaction ID *" placeholder="Transaction ID"
                  id="transaction_id" type="text" name="transaction_id" value={form?.transaction_id ?? ""} onChange={handleInput} />
                <InputField variant="auth" extra="w-full" label="Auth ID *" placeholder="Auth ID"
                  id="auth_id" type="text" name="auth_id" value={form?.auth_id ?? ""} onChange={handleInput} />
              </div>
            )}

            {form?.change_status_to && (
              <div className="csm-field-group">
                <label className="csm-checkbox-row">
                  <Checkbox id="isChangeStatusDate" value={!form?.isChangeStatusDate} name="isChangeStatusDate"
                    checked={form?.isChangeStatusDate} onChange={handleInput} className="h-4 w-4" />
                  <span className="csm-label" style={{ marginBottom: 0 }}>Override Status Date</span>
                </label>

                {form?.isChangeStatusDate && (
                  <div className="csm-datepicker-block">
                    <label className="csm-label">Current Date (read-only)</label>
                    <DatePicker
                      wrapperClassName="csm-dp-wrapper"
                      className="csm-datepicker"
                      popperClassName="csm-popper"
                      selected={new Date(new Date(info?.created_at?.replace("GMT", "")).toUTCString())}
                      disabled
                      dateFormat="yyyy-MM-dd HH:mm:ss"
                      onChange={() => {}}
                      popperPlacement="bottom-start"
                      withPortal={isMobile}
                    />
                    <label className="csm-label" style={{ marginTop: "12px" }}>
                      Change Date To <span className="csm-req">*</span>
                    </label>
                    <DatePicker
                      wrapperClassName="csm-dp-wrapper"
                      className="csm-datepicker"
                      popperClassName="csm-popper"
                      placeholderText="Select new date & time"
                      selected={form?.changeStatusDate}
                      timeInputLabel="Time:"
                      dateFormat="yyyy-MM-dd HH:mm:ss"
                      onChange={(d) => setForm((p: any) => ({ ...p, changeStatusDate: d }))}
                      showTimeInput
                      popperPlacement="bottom-start"
                      withPortal={isMobile}
                    />
                  </div>
                )}
              </div>
            )}

            {form?.change_status_to === "CHARGEBACK" && (
              <>
                <div className="csm-field-group">
                  <label className="csm-label">ARN Number</label>
                  <input className="csm-input" type="text" name="ARN_Number"
                    placeholder="Enter ARN number" value={form?.ARN_Number ?? ""} onChange={handleInput} />
                </div>
                <div className="csm-field-group">
                  <label className="csm-label">Reason</label>
                  <textarea className="csm-textarea" name="ReasonToChange" rows={3}
                    placeholder="Chargeback reason…" value={form?.ReasonToChange ?? ""} onChange={handleInput} />
                </div>
              </>
            )}
          </div>

          <div className="pconfirm-footer">
            <button className="pconfirm-btn-cancel" onClick={handleClose}>Cancel</button>
            <button className="pconfirm-btn-action--purple" onClick={handleSubmit} disabled={!!isLoading || client_is_deleted}>
              {isLoading ? <span className="pconfirm-spinner" /> : <><MdChangeCircle size={14} />Update Status</>}
            </button>
          </div>

          <style>{`
            .csm-datepicker-block { display:flex; flex-direction:column; gap:4px; margin-top:10px; }
            .csm-dp-wrapper { width:100% !important; display:block !important; }
            .csm-datepicker {
              width:100% !important; box-sizing:border-box !important; padding:10px 13px;
              background:#faf5ff; border:1.5px solid #e9d5ff; border-radius:10px;
              font-family:'Plus Jakarta Sans',sans-serif; font-size:13.5px; color:#0f172a;
              outline:none; cursor:pointer; transition:border-color 0.18s,box-shadow 0.18s;
            }
            .csm-datepicker:focus { border-color:#7c3aed; box-shadow:0 0 0 3px rgba(124,58,237,0.1); background:#fff; }
            .csm-datepicker:disabled { background:#f1f5f9; color:#94a3b8; cursor:not-allowed; }
            .csm-datepicker::placeholder { color:#c4b5fd; }
            .csm-field-group { display:flex; flex-direction:column; gap:7px; }
            .csm-label { font-size:12.5px; font-weight:700; color:#374151; margin-bottom:0; }
            .csm-req { color:#dc2626; }
            .csm-status-display { padding:10px 13px; background:#f8fafc; border:1.5px solid #e2e8f0; border-radius:10px; font-size:13.5px; font-weight:700; color:#0f172a; }
            .csm-select,.csm-input { width:100%; padding:10px 13px; background:#f8fafc; border:1.5px solid #e2e8f0; border-radius:10px; font-family:'Plus Jakarta Sans',sans-serif; font-size:13.5px; color:#0f172a; outline:none; box-sizing:border-box; transition:border-color 0.18s,box-shadow 0.18s; }
            .csm-select:focus,.csm-input:focus { border-color:#7c3aed; background:#fff; box-shadow:0 0 0 3px rgba(124,58,237,0.1); }
            .csm-textarea { width:100%; padding:10px 13px; resize:vertical; background:#f8fafc; border:1.5px solid #e2e8f0; border-radius:10px; font-family:'Plus Jakarta Sans',sans-serif; font-size:13.5px; color:#0f172a; outline:none; box-sizing:border-box; transition:border-color 0.18s,box-shadow 0.18s; }
            .csm-textarea:focus { border-color:#7c3aed; background:#fff; box-shadow:0 0 0 3px rgba(124,58,237,0.1); }
            .csm-checkbox-row { display:flex; align-items:center; gap:8px; cursor:pointer; }
            @media (max-width:480px) { .csm-datepicker { font-size:12.5px; padding:9px 11px; } }
          `}</style>
        </div>
      </Modal>

      {PANEL_STYLES}
    </>
  );
};

export default ChangeStatusModal;